import React from "react";

export default function LayoutRankPage({ children }) {
  return (
    <main id="main" className="main-result">
      {children}
    </main>
  );
}
